import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../components/common/CustomBootstrap';
import {reactTableText} from '../constants/configs';
import {keyBy, mapValues, omit} from 'lodash';
import {i18nizeDate} from '../helpers/Utils';
import ReactTableTextFilter from "../components/ReactTableTextFilter";
import ReactTableSelectFilter from "../components/ReactTableSelectFilter";
import BonusCardDetails from "./BonusCardDetails";
import UserInfo from "../components/UserInfo";
import Api from '../services/Api';

class UserBonuses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bonusCards: [],
      pages: -1,
      loading: false,
      updating: {},
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderTypeFilter = this.renderTypeFilter.bind(this);
    this.renderAssignTypeFilter = this.renderAssignTypeFilter.bind(this);
  }

  fetchData = async state => {
    const {userId} = this.props;
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/bonusPolicies',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            userId,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        });
      this.setState({
        bonusCards: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 200,
    },
    {
      Header: t('Bonus Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 140,
    },
    {
      Header: t('Bonus Type'),
      accessor: 'effectObject',
      filterable: true,
      Filter: this.renderTypeFilter,
      minWidth: 140,
    },
    {
      Header: t('Assign Type'),
      accessor: 'assignType',
      filterable: true,
      Filter: this.renderAssignTypeFilter,
      Cell: props => <span>{props.value || "MANUAL"}</span>,
      width: 140,
    },
    {
      Header: t('Recipient Type'),
      accessor: 'recipient.type',
      minWidth: 140,
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        if (type === "USER") {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
              textColor="text-success"
              label={t('User')}
              type={type}
              id={value}
            />
          );
        }
        return <span>{value || "ALL_USERS"}</span>;
      },
    },
    // {
    //   Header: t('Creator'),
    //   accessor: 'creator',
    //   Cell: props => {
    //     return (
    //       <UserInfo
    //         textColor="text-dark"
    //         label={t('Admin')}
    //         id={props.value}
    //         type="ADMIN"
    //       />
    //     );
    //   }
    // },
    {
      Header: t('Bonus Policy'),
      accessor: 'effectFunction.name',
      minWidth: 140,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      minWidth: 140,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    }
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CREATED', label: t('CREATED')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'ACTIVATED', label: t('ACTIVATED')},
      {value: 'STOPPED', label: t('STOPPED')},
      {value: 'EXPIRED', label: t('EXPIRED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderAssignTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'AUTO', label: 'AUTO'},
      {value: 'MANUAL', label: 'MANUAL'},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderTypeFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'REFERRAL', label: t('REFERRAL')},
      {value: 'MAX_REFERRAL', label: t('MAX_REFERRAL')},
      {value: 'TRADE_FEE', label: t('TRADE_FEE')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  render() {
    const {t} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary">
                {t('Bonus Cards')}
              </CardTitle>
              <ReactTable
                manual
                ref={el => {this.table = el;}}
                className="-highlight"
                data={this.state.bonusCards}
                pages={this.state.pages}
                loading={this.state.loading}
                sortable={false}
                resizable={true}
                onFetchData={this.fetchData}
                columns={this.getColumns(t)}
                defaultPageSize={10}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
                SubComponent={({original}) => <BonusCardDetails bonusCard={original} />}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UserBonuses);
